import React from 'react';

const UserProfile = ({ 
  showDetails = true, 
  size = 'default',
  className = '',
  variant = 'sidebar', // 'sidebar' | 'header'
  darkTheme = false
}) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    default: 'w-10 h-10',
    large: 'w-12 h-12'
  };

  const textSizes = {
    small: { name: 'text-xs', role: 'text-xs' },
    default: { name: 'text-sm', role: 'text-xs' },
    large: { name: 'text-base', role: 'text-sm' }
  };

  return (
    <div className={`flex items-center ${className}`}>
      <div 
        className={`rounded-full flex items-center justify-center ${sizeClasses[size]} shadow-lg`}
        style={{
          background: 'linear-gradient(135deg, #00d4ff, #0066ff)',
          boxShadow: '0 4px 16px rgba(0, 212, 255, 0.3)'
        }}
      >
        <span className="text-white text-sm font-bold">AD</span>
      </div>
      {showDetails && (
        <div className="ml-3">
          <p className={`font-semibold ${
            darkTheme ? 'text-text-primary' : 'text-gray-900'
          } ${textSizes[size].name}`}>
            Administrador
          </p>
          <p className={`${
            darkTheme ? 'text-text-muted' : 'text-gray-500'
          } ${textSizes[size].role}`}>
            {variant === 'sidebar' ? 'Administrador' : 'admin@ecpcapital.com'}
          </p>
        </div>
      )}
    </div>
  );
};

export default UserProfile;